import { msgState } from "components";
import { SField, SFieldProps } from "components/parts";
import { getFormError } from "messages";
import {
  useController,
  UseControllerProps,
  useFormContext,
} from "react-hook-form";
import { useSetRecoilState } from "recoil";
import { locationCd } from "services";

/**
 * テキストフィールド
 */

// TODO: エラーメッセージが初回Blur時に設定されない。

/**
 * プロパティ
 */
type Props = Pick<UseControllerProps, "name" | "rules"> &
  Partial<{
    size: number;
    password: boolean;
    location: boolean;
  }> &
  Partial<SFieldProps>;

/**
 * テキストフィールド
 *
 */
export const STextField = ({
  name,
  rules,
  size,
  password,
  location = false,
  label,
  required,
  ...props
}: Props): JSX.Element => {
  // フォーム設定
  const { control, trigger } = useFormContext();
  const { field, fieldState } = useController({
    name,
    control,
    rules: {
      ...rules,
      required: required && {
        value: required,
        message: getFormError("required", label ?? ""),
      },
    },
  });

  // エラーメッセージ設定
  const setMsg = useSetRecoilState(msgState);

  return (
    <SField
      {...props}
      name={field.name}
      value={field.value}
      formRef={field.ref}
      error={fieldState.invalid}
      onBlur={(event) => {
        trigger(name);
        props.onBlur?.call(this, event);
        setMsg(fieldState.error?.message || "");
      }}
      onChange={(event) => {
        const value = event.currentTarget.value;
        const defaultValue = event.currentTarget.defaultValue;
        if (location) {
          event.currentTarget.value = locationCd(value, defaultValue);
        }
        field.onChange(event);
        props.onChange?.call(this, event);
      }}
      type={password ? "password" : location ? "tel" : "text"}
      inputProps={{ maxLength: size }}
    />
  );
};
